/* eslint-disable quote-props */
/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable no-dupe-keys */
/* eslint-disable object-curly-newline */
// General imports
import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router';
// import { Link } from 'react-router-dom';
import SubBar from 'components/SubBar';

// Material-ui imports
import { Typography, Paper, withStyles, InputAdornment } from '@material-ui/core';

// icon imports
/* import StableIcon from 'assets/icon/dashboard/stable.png';
import PositionIcon from 'assets/icon/dashboard/position.png';
import BatteryIcon from 'assets/icon/dashboard/battery.png';
import EmergencyIcon from 'assets/icon/dashboard/emergency.png';
import NoPositionIcon from 'assets/icon/dashboard/no_position.png';
 */

// filter imports
import Filter from 'components/filter/Filter';
import FilterAutoComplete from 'components/filter/FilterAutoComplete';
import Search from '@material-ui/icons/Search';
import { buildUrl, updateQueryFilter } from 'utils/query';
import Permission from 'components/permissions/Permission';
// import { get } from 'services/fetch';

// hook imports
import { useAuthenticated, useFetch } from 'hooks/fetch';
import { useEffectSkipFirst } from 'hooks/common';

// utils
import { getEquipmentRowActions } from 'utils/equipment';
import {
  datetimeFormatter,
  percentageFormatter,
  latlongFormatter,
  poffFormatter,
} from 'utils/formatters';

// general project imports
import { CommandUnified } from 'components/commands/Commands';
import CommandLockModal from 'components/commands/CommandLockModal';
import SimpleTable from 'components/table/Table';
import { StatusColumn } from 'components/table/columns';
import ModalObs from 'components/modals/ModalObs';
import TableMenu, { TableColumn } from 'components/table/TableMenu';
import {
  isRfOn,
  formatPlatformPositionLabel,
  minutesToTimeString,
} from 'utils/helpers';
import { emitEvent } from 'utils/events';
import { getBreadcrumbsFor } from 'utils/breadcrumbs';
import { useAccessLog } from 'hooks/logs';

import theme from 'styles/theme';
import TableHeader from 'components/table/TableHeader';
import TableHeaderAction from 'components/table/TableHeaderAction';

import { saveAs } from 'file-saver';
import { logAction } from 'utils/logs';
import { fetchAuthenticated } from 'services/fetch';

import HomeFilterContext from 'pages/HomeFilterContext';

const EquipmentList = props => {
  const filterContext = useContext(HomeFilterContext);

  const genericSearchFields = [
    { label: 'Imei', name: 'imei' },
    { label: 'Código', name: 'code' },
    { label: 'Descrição', name: 'description' },
    { label: 'Tipo', name: 'equipmentType.name' },
    { label: 'Nome da Empresa', name: 'currentCompany.name' },
    { label: 'Cidade', name: 'currentCompany.addressCity.nome' },
    { label: 'Estado', name: 'currentCompany.addressState.nome' },
    { label: 'Veículo', name: 'vehicle' },
  ];

  // const [commonDashboardSettings, setCommonDashboardSettings] = useState({
  //   batteryBellowPercentage: 20,
  //   delayedPositions: 3,
  //   noPositioningTime: 12
  // });

  const { classes, location, match, history } = props;
  const { situation } = match.params;

  const situationInfo = {
    'total-ativos': { label: 'Total de equipamentos', color: '#538cc1' },
    'estaveis': {
      useDefaultFilters: true,
      additionalFilters: {
        $nor: [
          // Bateria abaixo do esperado
          {
            $or: [
              {
                'lastEventEquipment.protocolVersion': { $ne: 'V2' },
                'lastEventEquipment.rfTriangulation': false,
              },
              {
                dashboardCard: 'NOT_SET',
                situation: 'LOW_BATTERY',
                handlingStatus: { $ne: 'RF_ACTIVE' },
              },
              {
                dashboardCard: 'LOW_BATTERY',
              },
            ],
          },
          // Tempo sem posicionar
          {
            isActive: true,
            'currentCompany._id': { $exists: true },
            lastEvent: { $exists: true },
            situation: 'NO_POSITIONING',
            'lastEventEquipment.internalBatteryPercentage': { $gt: 1 }
          },
          // Aguardando ativação
          {
            situation: 'SCHEDULED',
          },
          {
            'poffCommands.0.status': "SCHEDULED"
          },
          // Equipamentos expirados
          {
            isActive: true,
            'currentCompany._id': { $exists: true },
            lastEvent: { $exists: true },
            "poffCommands.0.status": "COMPLETED",
            "status": "registered",
            "baitType.name": { "$in": ["Descartável", "Retornável", "Teste", "Customizada"] },
            $nor: [
              {
                situation: { $ne: 'STABLE' },
                currentHandlingStatus: 'emergency',
                'currentCompany._id': { $exists: true },
                lastEvent: { $exists: true },
                emergencyType: { $ne: 'NO_BATTERY' },
                isActive: true,
              }
            ]
          },
          // Sem bateria
          {
            currentHandlingStatus: 'emergency',
            situation: 'NO_BATTERY',
            emergencyType: 'NO_BATTERY',
            'currentCompany._id': { $exists: true },
            handlingStatus: { $ne: 'RF_ACTIVE' },
            isActive: true,
            lastEvent: { $exists: true },
            'lastEventEquipment.status.temperatureAlarm': false,
            'lastEventEquipment.status.temperatureAlarmMode': false,
            'lastEventEquipment.status.movementSensorAlarm': false,
            'lastEventEquipment.status.jammingDetected': false
          },
          // Emergências
          {
            situation: { $ne: 'STABLE' },
            currentHandlingStatus: 'emergency',
            'currentCompany._id': { $exists: true },
            lastEvent: { $exists: true },
            emergencyType: { $ne: 'NO_BATTERY' },
            isActive: true,
          },
          // RF Ativo
          {
            $or: [
              {
                situation: 'STABLE',
                isActive: true,
                'currentCompany._id': { $exists: true },
                lastEvent: { $exists: true },
                $or: [
                  {
                    'lastEventEquipment.protocolVersion': 'V2',
                    $or: [
                      { 'lastEventEquipment.status.transmitter434Mhz': true },
                      { 'lastEventEquipment.status.transmitter928Mhz': true },
                    ],
                  },
                  {
                    'lastEventEquipment.protocolVersion': { $ne: 'V2' },
                    'lastEventEquipment.rfTriangulation': true,
                  },
                ],
              },
            ],
          }
        ],
        // Adicione aqui quaisquer outras condições gerais que se aplicam a todos os Equipamentos Estáveis
        // Por exemplo, se todos os Equipamentos Estáveis devem estar ativos:
        isActive: true,
        'currentCompany._id': { $exists: true },
        lastEvent: { $exists: true },
      },
      situation: { $ne: '' },
      label: 'Equipamentos estáveis',
      color: '#5bf293',
    },
    'bateria-baixa': {
      useDefaultFilters: true,
      additionalFilters: {
        $or: [
          {
            'lastEventEquipment.protocolVersion': 'V2',
            'lastEventEquipment.status.transmitter434Mhz': false,
            'lastEventEquipment.status.transmitter928Mhz': false,
            'lastEventEquipment.status.temperatureAlarm': false,
            'lastEventEquipment.status.temperatureAlarmMode': false,
            'lastEventEquipment.status.movementSensorAlarm': false,
            'lastEventEquipment.status.jammingDetected': false
          },
          {
            'lastEventEquipment.protocolVersion': { $ne: 'V2' },
            'lastEventEquipment.rfTriangulation': false,
          },
        ],
        $or: [
          {
            dashboardCard: 'NOT_SET',
            isActive: true,
            'currentCompany._id': { $exists: true },
            lastEvent: { $exists: true },
            situation: 'LOW_BATTERY',
            handlingStatus: { $ne: 'RF_ACTIVE' },
          },
          {
            dashboardCard: 'LOW_BATTERY',
          },
        ],
      },
      situation: { $ne: '' },
      label: 'Equipamentos com bateria baixa',
      color: '#fbe622',
    },
    'sem-posicionar': {
      useDefaultFilters: true,
      additionalFilters: {
        situation: 'NO_POSITIONING',
        'lastEventEquipment.internalBatteryPercentage': { $gt: 1 },
      },
      situation: 'NO_POSITIONING',
      label: 'Equipamentos sem posicionar',
      color: '#ffc500',
    },
    'posicoes-atrasadas': {
      useDefaultFilters: true,
      situation: 'DELAYED_POSITIONS',
      label: 'Equipamentos com posições atrasadas',
      color: '#fd8f44',
    },
    'aguardando-ativacao': {
      useDefaultFilters: true,
      additionalFilters: {
        $or: [
          {

            'poffCommands.0.status': "SCHEDULED"
          },
          {
            situation: 'SCHEDULED',
          }

        ]
      },
      label: 'Equipamentos aguardando ativação',
      color: '#ffa263',
    },
    expirados: {
      additionalFilters: {
        // dashboardCard: 'NOT_SET',
        isActive: true,
        lastEvent: { $exists: true },
        // situation: 'COMPLETED',
        'currentCompany._id': { $exists: true },
        "poffCommands.0.status": "COMPLETED",
        "status": "registered",
        "baitType.name": {
          "$in": [
            "Descartável",
            "Retornável",
            "Teste",
            "Customizada"
          ]
        },
        // $or: [
        //   {
            
        //   },
          // {
          //   dashboardCard: 'EXPIRED',
          // },
        // ],
      },
      // situation: { $ne: '' },
      useDefaultFilters: false,
      label: 'Equipamentos expirados',
      color: '#e58744',
    },
    'sem-bateria': {
      additionalFilters: {
        currentHandlingStatus: 'emergency',
        situation: 'NO_BATTERY',
        emergencyType: 'NO_BATTERY',
        'currentCompany._id': { $exists: true },
        handlingStatus: { $ne: 'RF_ACTIVE' },
        isActive: true,
        lastEvent: { $exists: true },
        'lastEventEquipment.status.temperatureAlarm': false,
        'lastEventEquipment.status.temperatureAlarmMode': false,
        'lastEventEquipment.status.movementSensorAlarm': false,
        'lastEventEquipment.status.jammingDetected': false
      },
      useDefaultFilters: true,
      situation: { $ne: '' },
      label: 'Equipamentos sem bateria',
      color: '#ec6a69',
    },
    'jammer-detectado': {
      additionalFilters: {
        situation: { $ne: 'STABLE' },
        currentHandlingStatus: 'emergency',
        'currentCompany._id': { $exists: true },
        lastEvent: { $exists: true },
        emergencyType: { $ne: 'NO_BATTERY' },
        isActive: true,
      },
      useDefaultFilters: true,
      situation: { $ne: '' },
      label: 'Equipamentos em emergência',
      color: '#e44a4a',
    },
    'rf-ativo': {
      additionalFilters: {
        $or: [
          {
            situation: 'STABLE',
            isActive: true,
            'currentCompany._id': { $exists: true },
            lastEvent: { $exists: true },
            $or: [
              {
                'lastEventEquipment.protocolVersion': 'V2',
                $or: [
                  {
                    'lastEventEquipment.status.transmitter434Mhz': true,
                  },
                  {
                    'lastEventEquipment.status.transmitter928Mhz': true,
                  },
                ],
              },
              {
                'lastEventEquipment.protocolVersion': { $ne: 'V2' },
                'lastEventEquipment.rfTriangulation': true,
              },
            ],
          },
        ],
      },
      useDefaultFilters: true,
      situation: { $ne: '' },
      label: 'Equipamentos com RF ATIVO',
      color: '#dd0c0b',
    },
    'fora-de-cerca': {
      useDefaultFilters: true,
      additionalFilters: {
        isInsideFence: false,
      },
      situation: { $ne: '' },
      label: 'Equipamentos fora de cerca',
      color: '#FF6B35',
    },
  };

  useAccessLog(
    `Acesso a lista de ${situationInfo[situation].label.toLowerCase()}`
  );

  const breadcrumbs = getBreadcrumbsFor(location.pathname);

  const [reload, setReload] = useState(false);
  const onModalObsSubmit = () => {
    setReload(!reload);
  };

  // eslint-disable-next-line no-unused-vars
  const [chips, setChips] = useState(
    (filterContext && filterContext.searchTerm) || []
  );

  const queryObject = {
    sort: { 'lastEvent.timestamp': -1 },
    filter: {
      'currentCompany._id': {
        ...(filterContext.company
          ? { value: filterContext.company._id, toObjectId: false }
          : { $exists: true }),
      },
      lastEvent: { $exists: true },
      isActive: true,
      ...(filterContext.equipment && { _id: filterContext.equipment._id }),
      ...(filterContext.searchTerm && {
        searchText: filterContext.searchTerm,
        genericSearchFields: genericSearchFields.map(field => field.name),
      }),
    },
  };

  if (situationInfo[situation].situation) {
    // set default query
    queryObject.filter = {
      ...queryObject.filter,
      ...(situationInfo[situation].additionalFilters || {}),
      situation: situationInfo[situation].situation,
    };
  } else {
    queryObject.filter = {
      // ...queryObject.filter,
      ...(situationInfo[situation].additionalFilters || {}),
      // situation: situationInfo[situation].situation,
    };
  }

  const [query, setQuery] = useState({
    queryString: `?filter=${JSON.stringify(
      queryObject.filter
    )}&sort=${JSON.stringify(queryObject.sort)}`,
    queryObject,
  });

  const basePath = 'equipment/situation';
  const [fetchPath, setFetchPath] = useState(
    buildUrl(basePath, location) + query.queryString
  );

  // Load equipments from server
  const { data } = useAuthenticated(useFetch, fetchPath, {
    beforeFetch: () => {
      emitEvent('showGlobalLinearProgress');
    },
    afterFetch: () => {
      emitEvent('hideGlobalLinearProgress');
    },
    reload,
  });

  // Update query string
  // necessary to filters to work
  useEffectSkipFirst(async () => {
    if (filterContext) {
      filterContext.updateSearchTerm(query.queryObject.filter.searchText);
    }

    if (query.queryString) {
      setFetchPath(`${basePath}${query.queryString}`);
    }
  }, [query]);

  const handleExportXLS = async query => {
    try {
      const response = await fetchAuthenticated(
        'GET',
        `equipment/report/xls${query.queryString}`
      );

      const blob = await response.blob();
      saveAs(blob, `Relatorio_Equipamentos_${situation}.xls`);
      logAction('Exportou relatório de expirados em XLS');
    } catch (err) {
      console.log(err);
    } finally {
      console.log('Done!');
    }
  };

  const onMenuItemClick = () => {
    setReload(!reload);
  };
  const rowStatusActions = getEquipmentRowActions(onMenuItemClick);
  const lockCommandAction = {
    label: 'Comandos Cadeado',
    permission: 'SendLockCommand',
    component: (props, setCurrentAction) => (
      <CommandLockModal
        isOpen
        setCurrentAction={setCurrentAction}
        lock={props.lock}
        {...props}
      />
    ),
  };

  const rowActions = [
    {
      label: 'Comandos',
      component: props => <CommandUnified showStatus={true} isVisible={true} {...props} />,
    },
    {
      label: 'Observações',
      component: props => (
        <ModalObs
          onSubmit={onModalObsSubmit}
          equipment={props}
          isVisible={true}
          {...props}
        />
      ),
    },
  ];

  const columns = [
    { label: 'Equip.', value: row => row.shortImei, sort: 'shortImei' },
    { label: 'Placa / LP', value: row => row.vehicle, sort: 'vehicle' },
    {
      label: 'Tipo',
      value: row => row.equipmentType && row.equipmentType.name,
      sort: 'equipmentType.name',
    },
    {
      label: 'Empresa',
      value: row => row.currentCompany && row.currentCompany.name,
      sort: 'currentCompany.name',
    },
    /* situation === 'bateria-baixa' || situation === 'sem-posicionar'
      ? {
        label: 'Configuração',
        value: row => {
          try {
            if (situation === 'bateria-baixa') {
              if (
                'dashboardSettings' in row.currentCompany &&
                  row.currentCompany.dashboardSettings !== null &&
                  'noPositioningTime' in row.currentCompany.dashboardSettings &&
                  'batteryBelowPercentage' in
                    row.currentCompany.dashboardSettings
              ) {
                return `Abaixo de ${row.currentCompany.dashboardSettings.batteryBelowPercentage}%`;
              }
              return `Abaixo de ${20}%`;
            }
            if (
              'dashboardSettings' in row.currentCompany &&
                  row.currentCompany.dashboardSettings !== null &&
                  'noPositioningTime' in row.currentCompany.dashboardSettings &&
                  'batteryBelowPercentage' in
                    row.currentCompany.dashboardSettings
            ) {
              return `${row.currentCompany.dashboardSettings.noPositioningTime} horas`;
            }
            return `${12} horas`;
          } catch (e) {
            return '';
          }
        },
      }
      : {}, */
    {
      label: 'Bat.',
      value: row => {
        const ev = row.lastEventEquipment || row.lastEvent;
        return (ev &&
          `${percentageFormatter(
            Number(
              (ev.adjustedInternalBatteryPercentage ||
                ev.internalBatteryPercentage) / 100
            )
          )}`) ||
        '-';
      },
      sort: 'lastEventEquipment.internalBatteryPercentage',
    },
    { label: 'Exp.', value: row => poffFormatter(row) },
    {
      label: 'Transmissão',
      value: row => row.lastEvent && formatPlatformPositionLabel(row.lastEvent, true),
    },
    {
      label: 'Sinal',
      value: row => {
        const ev = row.lastEventEquipment || row.lastEvent;
        return ev && ev.gsmModelSignal &&
        `${Math.round(
          (parseInt(ev.gsmModelSignal, 10) / 31) * 100
        )}%`;
      },
      sort: 'lastEventEquipment.gsmModelSignal',
    },
    {
      label: 'Data/hora',
      value: row => (row.lastEvent && `${datetimeFormatter(row.lastEvent.timestamp)}`) ||
        '',
      sort: 'lastEvent.timestamp',
    },
    { label: 'RF', value: row => isRfOn(row.lastEventEquipment || row.lastEvent) },
    {
      label: 'FPP.',
      value: row => {
        const ev = row.lastEventEquipment || row.lastEvent;
        return ev && minutesToTimeString(ev.positionSendInterval);
      },
      sort: 'lastEventEquipment.positionSendInterval',
    },
    {
      label: 'Local',
      value: row => {
        if (row.lastEvent) {
          if (row.lastEvent.isInsideReferencePoint) {
            return row.lastEvent.referencePointLocal;
          }
          return row.lastEvent.local;
        }
        return '';
      },
      sort: 'lastEvent.local',
    },
    {
      label: 'Lat/Long',
      value: row => (row.lastEvent &&
          `${latlongFormatter(
            row.lastEvent.latitude,
            row.lastEvent.longitude
          )}`) ||
        '',
      sort: '',
    },
    {
      label: 'ICCID',
      value: row => {
        if (row.iccid) {
          return row.iccid;
        }
        return '-';
      },
      sort: 'lastEventEquipment.iccid',
    },
    {
      label: 'ID Módulo LORA',
      value: row => {
        if (row.lastEvent) {
          return row.lastLoraModuleId || '-';
        }
        return '-';
      },
      sort: 'iccid',
    },
    {
      label: 'Status',
      component: row => (
        <Permission
          key={`Status${row._id}`}
          name="EditEquipmentStatus"
          ifNoPermission={(
            <TableColumn>
              <StatusColumn
                edit={false}
                status={row.handlingStatus}
                color={situationInfo[situation].color}
              />
            </TableColumn>
          )}
        >
          <TableMenu
            row={row}
            rowActions={rowStatusActions}
            icon={(
              <StatusColumn
                status={row.handlingStatus}
                color={situationInfo[situation].color}
              />
            )}
          />
        </Permission>
      ),
    },
    {
      label: '',
      // eslint-disable-next-line no-unused-vars
      component: (row, col) => (
        <Permission
          key={`Config${row._id}`}
          names={[
            'SendGPRSCommand',
            'SendAdminCommand',
            'EditEquipmentObservations',
          ]}
        >
          <TableMenu row={row} rowActions={row.lock ? [...rowActions, lockCommandAction] : rowActions} />
        </Permission>
      ),
    },
  ];

  const filterAsyncFields = [
    {
      name: 'companies',
      component: args => (
        <FilterAutoComplete
          {...args}
          menuContainerStyle={{
            marginTop: 5,
          }}
          placeholder="Empresa"
          showPlaceholder={true}
          hideLabel={true}
          path="company?notPaginated=true"
          name="companies"
          getOptionLabel={opt => opt.name}
          loadingMessage="Carregando empresas..."
          noOptionsMessage="Nenhuma empresa encontrada."
          onChange={args => {
            const { opt, fields, setIsLoading, isLoading, filterHandler } =
                args;
              // reset equipments filter
            fields.equipments.current.resetField();
            setIsLoading({ ...isLoading, equipments: true });
            filterContext.updateCompany(opt);
            if (!opt) {
              filterHandler.removeFilter('currentCompany._id');
            } else {
              // update equipments available for filtering
              filterHandler.updateQueryFilter({
                'currentCompany._id': { value: opt._id, toObjectId: false },
              });
            }
          }}
          value={filterContext.company}
        />
      ),
    },
    {
      name: 'equipments',
      component: args => (
        <FilterAutoComplete
          {...args}
          menuContainerStyle={{
            marginTop: 5,
          }}
          placeholder="Equipamentos"
          showPlaceholder={true}
          hideLabel={true}
          path={
              `equipment/list?fields=_id,imei,ignoreTimeUntillNextPosition&${
                query.queryString.substr(1)}`
            }
          name="equipments"
          getOptionLabel={opt => opt.imei}
          loadingMessage="Carregando equipamentos..."
          noOptionsMessage="Nenhum equipamento encontrado."
          onChange={args => {
            const { opt, filterHandler } = args;
            filterContext.updateEquipment(opt);
            if (!opt) {
              filterHandler.removeFilter('_id');
            } else {
              filterHandler.updateQueryFilter({
                _id: opt._id,
              });
            }
          }}
          whenIsLoading={({
            fetchUrl,
            path: defaultPath,
            setFetchUrl,
            fields,
          }) => {
            const companyField = fields.companies.current.value;
            if (companyField) {
              setFetchUrl(
                updateQueryFilter(fetchUrl, {
                  'currentCompany._id': {
                    value: companyField._id,
                    toObjectId: false,
                  },
                })
              );
            } else {
              setFetchUrl(defaultPath);
            }
          }}
          value={filterContext.equipment}
        />
      ),
    },
  ];

  return (
    <div>
      <SubBar breadcrumbs={breadcrumbs} items={[]} match={match} />
      <div
        style={{
          backgroundColor: situationInfo[situation].color,
          height: 5,
          width: '100%',
        }}
      />
      <div className={classes.root}>
        {/* <div className={classes.header}> */}
        {/* <img src={situationInfo[situation].icon} className={classes.cardIcon}></img> */}
        {/* <Typography className={classes.headerText}>{situationInfo[situation].label}</Typography> */}
        {/* </div> */}
        <Filter
          searchPlaceHolder="Buscar"
          query={query}
          setQuery={setQuery}
          containerStyle={{ paddingLeft: 0 }}
          asyncFields={filterAsyncFields}
          inputProps={{
            startAdornment: (
              <InputAdornment position="start" className={classes.searchIcon}>
                <Search />
              </InputAdornment>
            ),
          }}
          showPlaceholder={true}
          hideLabel={true}
          genericSearchFields={genericSearchFields}
          defaultChips={chips}
        />
        <Paper elevation={0} className={classes.paper}>
          <SimpleTable
            columns={columns}
            data={data}
            query={query}
            setQuery={setQuery}
            // eslint-disable-next-line no-unused-vars
            onRowClick={(row, col) => {
              history.push(`/detalhes-equipamento/${row._id}`, {
                from: location,
              });
            }}
            HeaderComponent={(
              <TableHeader
                headerActions={[
                  <TableHeaderAction
                    title="Exportar XLS"
                    IconProps={{ style: theme.custom.icon }}
                    Icon={props => <Typography {...props}>XLS</Typography>}
                    disabled={data && data.totalItems === 0}
                    onClick={() => handleExportXLS(query)}
                  />,
                ]}
              />
            )}
          />
        </Paper>
      </div>
    </div>
  );
};

const styles = theme => ({
  root: {
    // paddingTop: theme.main.padding.top,
    // paddingBottom: theme.main.padding.bottom,
    paddingLeft: theme.main.padding.left,
    paddingRight: theme.main.padding.right,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.gray.gray_4,
    fontSize: 22,
    lineHeight: 'normal',
  },
  paper: {
    display: 'flex',
    borderRadius: theme.border.radius,
  },
  button: {
    textTransform: 'none',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: theme.main.padding.bottom,
  },
  headerText: {
    marginLeft: 16,
    fontSize: 18,
    fontWeight: 'bold',
    color: theme.palette.gray.gray_1,
  },
  cardIcon: {
    width: 34,
    height: 34,
  },
  searchIcon: {
    color: theme.palette.gray.gray_5,
  },
});

export default withRouter(withStyles(styles)(EquipmentList));
